module.exports = __webpack_public_path__ + "static/project-rebound-73eba9eef8731032bf2f3812d84bcf86.jpg";